const getters = {
  userInfo: state => state.index.userInfo
}
export default getters
